module.exports = __webpack_public_path__ + "static/smn_logo3-4679c2d2ef4c3229b51fb48113218b02.png";